const steps = [
  {
    n: "01",
    title: "Tell us your products",
    body: "Paste your Amazon product links or your storefront URL. We pull your reviews automatically.",
  },
  {
    n: "02",
    title: "We read every review",
    body: "We find the ones that break Amazon's rules — fake reviews, spam, off-topic complaints, harassment, and more.",
  },
  {
    n: "03",
    title: "We prepare the case for Amazon",
    body: "We cite the policy issue and prepare the report. For brands with verified Registered Agent access, we can file eligible reports through Brand Registry Support.",
  },
];

export function HowItWorks() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">
          How it works
        </h2>
        <p className="mt-3 text-slate-600 dark:text-slate-400">
          From catalog monitoring to a clear, policy-based next step.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {steps.map((s) => (
          <div
            key={s.n}
            className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900"
          >
            <div className="text-xs font-mono text-slate-400 dark:text-slate-500 tracking-wider">
              {s.n}
            </div>
            <h3 className="mt-3 font-medium text-slate-900 dark:text-slate-100">{s.title}</h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              {s.body}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
